import { AuctionTime, AuctionTimeResponse } from "@/features/home/types";
import { getTwentyTwoColorCodeList } from "@/features/home/utils";
import { getAuctionTimeGroupTextList } from "@/features/home/utils";

export const processAuctionTime = (data: AuctionTimeResponse): AuctionTime => {
  const processedData = {
    labels: [],
    series: [],
    colorList: [],
  } as AuctionTime;

  const tmpAuctionTime = {} as any;
  const sortAuctionTime = data.auctionTime;
  let isContainNullDataForAuctionTime = false;

  sortAuctionTime.forEach(element => {
    if (element.vendor in tmpAuctionTime === false) {
      tmpAuctionTime[element.vendor] = [];
      // 該当vendorのデータのみ取得
      const auctionTimeDataForVendor = sortAuctionTime.filter(x => x.vendor === element.vendor);
      auctionTimeDataForVendor.sort((a, b) => {
        if (a.auctionTimeGroupId < b.auctionTimeGroupId) return -1;
        if (a.auctionTimeGroupId > b.auctionTimeGroupId) return 1;
        return 0;
      });
      // 同一vendor内で auctionTimeGroupId の順にデータ格納
      auctionTimeDataForVendor.forEach(auctionTimedata => {
        tmpAuctionTime[element.vendor].push(auctionTimedata.impression);
        if (!isContainNullDataForAuctionTime && auctionTimedata.impression === null) {
          isContainNullDataForAuctionTime = true;
        }
      });
    }
  });
  // グラフに描画するデータの整形
  const tmpChartDatasetList = [] as {
    name: string;
    data: number[];
  }[];

  for (let i = 0; i < Object.keys(tmpAuctionTime).length; i++) {
    const chartDataset = {} as { name: string; data: number[] };
    chartDataset["name"] = Object.keys(tmpAuctionTime)[i];
    chartDataset["data"] = tmpAuctionTime[Object.keys(tmpAuctionTime)[i]];
    tmpChartDatasetList.push(chartDataset);
  }
  processedData["labels"] = getAuctionTimeGroupTextList();
  processedData["series"] = tmpChartDatasetList;
  processedData["colorList"] = getTwentyTwoColorCodeList();

  return processedData;
};
